import _ from 'underscore';
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import Container from 'components/Container';
import MultirowSlideSection from 'components/MultirowSlideSection';
import Section from 'components/Section';
import SimpleGrid from 'components/SimpleGrid';
import SizeDependedBlock from 'components/SizeDependedBlock';
import MovieCard from 'components/cards/MovieCard';

const ConcertsCatalog = ({ concerts }) => {
	const sectionTitle = 'Концерты онлайн';

	const moreControl = useMemo(
		() => ({ title: 'Все концерты', url: '/music/concerts' }),
		[]
	);

	return (
		<SizeDependedBlock>
			<MultirowSlideSection
				title={sectionTitle}
				items={concerts}
				moreControl={moreControl}
				CardComponent={MovieCard}
				gridSize={2}
				direction="columns"
				TitleTag="h1"
			/>
			<Section title={sectionTitle} TitleTag="h1" moreControl={moreControl}>
				<Container>
					<SimpleGrid>
						{_(concerts).map((block) => (
							<MovieCard key={block._id} data={block} />
						))}
					</SimpleGrid>
				</Container>
			</Section>
		</SizeDependedBlock>
	);
};

ConcertsCatalog.propTypes = {
	concerts: PropTypes.array
};

ConcertsCatalog.defaultProps = {
	concerts: []
};

export default ConcertsCatalog;
